var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ round: _vm.round },attrs:{"id":"cropperImg"}},[_c('img',{ref:"cropperImg",attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }